import React from 'react';
import { Bot, Clock, Sparkles, Gift } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const AIFeatureSection = () => {
  const { t } = useLanguage();
  
  return (
    <section className="py-16 bg-yellow-400 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 bg-yellow-200 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/3 w-72 h-72 bg-amber-200 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="bg-gray-900/90 backdrop-blur-xl rounded-3xl p-8 md:p-12 shadow-2xl">
          <div className="flex flex-col md:flex-row items-center gap-8">
            {/* Icon Side */}
            <div className="flex-shrink-0">
              <div className="relative">
                <div className="w-24 h-24 md:w-32 md:h-32 bg-yellow-400 rounded-3xl flex items-center justify-center shadow-2xl transform hover:scale-110 transition-all duration-300">
                  <Bot className="w-12 h-12 md:w-16 md:h-16 text-gray-900" />
                </div>
                <div className="absolute -top-3 -right-3 bg-white text-gray-900 px-3 py-1 rounded-full text-xs font-bold shadow-lg animate-bounce">
                  {t('aiFeature.free')}
                </div>
              </div>
            </div>

            {/* Content Side */}
            <div className="flex-1 text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-3">
                <Sparkles className="w-6 h-6 text-yellow-400" />
                <span className="text-yellow-400 font-bold text-sm uppercase tracking-wider">
                  {t('aiFeature.bonus')}
                </span>
              </div>
              
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {t('aiFeature.title')}
              </h2>
              
              <p className="text-lg md:text-xl text-white/95 mb-6 leading-relaxed">
                <span className="font-bold text-yellow-400">{t('aiFeature.description')}</span> <span className="font-bold text-yellow-400">{t('aiFeature.descriptionHighlight')}</span> {t('aiFeature.descriptionEnd')}
              </p>

              <div className="flex flex-wrap gap-4 justify-center md:justify-start">
                <div className="flex items-center gap-2 bg-yellow-400/20 backdrop-blur-sm px-4 py-2 rounded-full border border-yellow-400/30">
                  <Clock className="w-5 h-5 text-yellow-400" />
                  <span className="text-white font-bold">{t('aiFeature.access247')}</span>
                </div>
                <div className="flex items-center gap-2 bg-yellow-400/20 backdrop-blur-sm px-4 py-2 rounded-full border border-yellow-400/30">
                  <Bot className="w-5 h-5 text-yellow-400" />
                  <span className="text-white font-bold">{t('aiFeature.aiPowered')}</span>
                </div>
                <div className="flex items-center gap-2 bg-yellow-400/20 backdrop-blur-sm px-4 py-2 rounded-full border border-yellow-400/30">
                  <Gift className="w-5 h-5 text-yellow-400" />
                  <span className="text-white font-bold">{t('aiFeature.free2')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIFeatureSection;
